<div class="container-fluid col-12 col-md-10 h-100">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>
    <div class="p-3">
        <div class="row g-1 row-cols-sm-3 row-cols-1 mb-3">
            <div class="col">
                <div class="border rounded-1 background-light h-100 p-2">

                    <div class="row mb-3">
                        <h3 class="col text-center">Station</h3>
                    </div>
                    <!-- <div class="card-body"> -->
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end card-text label">Code</div>
                        <div class="col-8 px-1 text-start card-text">{{model.SamplingPoint.CodeStation}}</div>
                    </div>
                    <mat-divider class="m-2"></mat-divider>
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end card-text label">Typologie</div>
                        <div class="col-8 px-1 text-start card-text">{{model.SamplingPoint.Typologie}}</div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div class="col">
                <div class="border rounded-1 background-light d-flex flex-column p-2 h-100">
                    <div class="row mb-3">
                        <h3 class="col text-center">Intervention</h3>
                    </div>
                    <!-- <h5 class="card-header">Intervention</h5> -->
                    <!-- <div class="card-body"> -->
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end label">Code</div>
                        <div class="col-8 px-1 text-start ">{{model.Code}}</div>
                    </div>
                    <mat-divider class="m-2"></mat-divider>
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end label">Type</div>
                        <div class="col-8 px-1 text-start ">{{getInterventionTypeName()}}</div>
                    </div>
                    <mat-divider *ngIf="model.Type === 2" class="m-2"></mat-divider>
                    <div *ngIf="model.Type === 2" class="row align-items-center">
                        <div class="col-4 px-1 text-end  label">Grpt</div>
                        <div class="col-8 px-1 text-start ">
                            <p *ngIf="model.GroupementPrelevement" class="">3 phases </p>
                            <p *ngIf="!model.GroupementPrelevement" class="">12 pots </p>
                        </div>
                    </div>
                    <!-- </div> -->
                    <!-- <div class="card-footer"> -->
                    <div class="row align-items-center mt-auto">
                        <div class="col me-3 text-end"><small class="text-muted">{{model.CreatedOn | date}}</small></div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div class="col">
                <div class="border rounded-1 background-light h-100 p-2">
                    <div class="row mb-3">
                        <h3 class="col text-center">Tournée</h3>
                    </div>
                    <!-- <h5 class="card-header">Tournée</h5> -->
                    <!-- <div class="card-body"> -->
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end  label">Station</div>
                        <div class="col-8 px-1 text-start ">{{model.SamplingPoint.SamplingPointName}}</div>
                    </div>
                    <mat-divider class="m-2"></mat-divider>
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end  label">Adresse</div>
                        <div class="col-8 px-1 text-start ">{{model.SamplingPoint.AddressLine1}}</div>
                    </div>
                    <mat-divider class="m-2"></mat-divider>
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-end  label">Ville</div>
                        <div class="col-8 px-1 text-start ">{{model.SamplingPoint.City}}</div>
                    </div>
                    <!-- </div>
                    <div class="card-footer"> -->
                    <div class="row align-items-center">
                        <div *ngIf="model?.Date" class="col me-3 text-end"><small class="text-muted">{{model.Date | date}}</small></div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="border rounded-1 background-light p-4">
            <div class="row">
                <mat-form-field class="col-12 col-md">
                    <mat-label>Préleveur 1</mat-label>
                    <mat-select placeholder="Préleveur 1" [(ngModel)]="model.Sampler" [compareWith]="compareUser" required>
                        <mat-option *ngFor="let u of AllUserList" [value]="u">
                            <span>{{u.Fullname}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Préleveur 2</mat-label>
                    <mat-select placeholder="Préleveur 2" [(ngModel)]="model.Responsible" [compareWith]="compareUser" required>
                        <mat-option *ngFor="let u of AllUserList" [value]="u">
                            <span>{{u.Fullname}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
   
                <mat-form-field *ngIf="model.Type === EInterventionType.MGCE" class="col-12 col-md">
                    <mat-label>Préleveur 3</mat-label>
                    <mat-select placeholder="Préleveur 3" [(ngModel)]="model.Sampler3" [compareWith]="compareUser" required>
                        <mat-option *ngFor="let u of AllUserList" [value]="u">
                            <span>{{u.Fullname}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-12 col">
                    <mat-label>Date</mat-label>
                    <input matInput placeholder="Date" [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()" (dateChange)="dateChanged($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-12 col">
                    <mat-label>Heure</mat-label>
                    <input matInput placeholder="Heure" [ngxTimepicker]="timepicker" [value]="interventionTime" [format]="24" readonly>
                    <ngx-material-timepicker #timepicker (timeSet)="timeSet($event)"></ngx-material-timepicker>
                </mat-form-field>

                <mat-form-field class="col-12 col">
                    <mat-label>Durée (min)</mat-label>
                    <input matInput placeholder="Durée (min)" type="number" [(ngModel)]="model.SamplingDuration">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Accès et sécurité</mat-label>
                    <input matInput placeholder="Accès et sécurité" [(ngModel)]="model.GeographicAccess">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Commentaire</mat-label>
                    <input matInput placeholder="Commentaire" [(ngModel)]="model.Tracabilite.Comment">
                </mat-form-field>
            </div>
            <div class="row">

                <mat-form-field class="col">
                    <mat-label>Vérificateur</mat-label>
                    <mat-select placeholder="Vérificateur" [(ngModel)]="model.Tracabilite.Verificateur" [compareWith]="compareUser" required>
                        <mat-option *ngFor="let u of AllUserList" [value]="u">
                            <span>{{u.Fullname}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="col-12 col-sm-6">
                    <mat-label>Code outil</mat-label>
                    <input matInput placeholder="Code outil" [(ngModel)]="model.Tracabilite.CodeOutil" [disabled]="model.Type === 3">
                </mat-form-field>

            </div>

            <div class="row align-items-center">
                <mat-slide-toggle class="col col-md-auto" [(ngModel)]="model.Tracabilite.EcartProtocole.Ecart">Ecart Protocole </mat-slide-toggle>
                <mat-form-field class="col-12 col-md">
                    <mat-label>Justification</mat-label>
                    <input matInput placeholder="Justification" [(ngModel)]="model.Tracabilite.EcartProtocole.Justification" [disabled]="!model.Tracabilite.EcartProtocole.Ecart">
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field *ngIf="model.Type === 1" class="col">
                    <mat-label>Nombre de pots</mat-label>
                    <input matInput placeholder="Nombre de pots" type="number" [(ngModel)]="model.Tracabilite.NombrePotPhase1">
                </mat-form-field>

                <mat-form-field *ngIf="model.Type === 2 || model.Type === 7" class="col">
                    <mat-label>Nombre de pots phase A</mat-label>
                    <input matInput placeholder="Nombre de pots phase A" type="number" [(ngModel)]="model.Tracabilite.NombrePotPhase1">
                </mat-form-field>

                <mat-form-field *ngIf="model.Type === 2 || model.Type === 7" class="col">
                    <mat-label>Nombre de pots phase B</mat-label>
                    <input matInput placeholder="Nombre de pots phase B" type="number" [(ngModel)]="model.Tracabilite.NombrePotPhase2">
                </mat-form-field>

                <mat-form-field *ngIf="model.Type === 2 || model.Type === 7" class="col">
                    <mat-label>Nombre de pots phase C</mat-label>
                    <input matInput placeholder="Nombre de pots phase C" type="number" [(ngModel)]="model.Tracabilite.NombrePotPhase3">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div *ngIf="DocumentList.length > 0" class="px-3">
        <div class="row justify-content-start">
            <div class="col-12 col-md-4 col-xl-2 my-1" *ngFor="let d of DocumentList">
                <div class="border rounded-1 background-light p-2">
                    <!-- <h5 class="card-header">{{ getDocumentTypeName(d.DocumentType)}}</h5> -->
                    <div class="row mb-3">
                        <h5 class="col text-center">{{ getDocumentTypeName(d.DocumentType)}}</h5>
                    </div>

                    <div class="row">
                        <div class="text-center"><small class="text-muted">{{d.Name}}</small></div>
                    </div>
                    <div class="row d-flex flex-row-reverse document-footer mt-2">
                        <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteDocument(d)" [disabled]="CanDeleteDocument(d) || d.UIDisabled">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getDocumentFile(d)" [disabled]="d.UIDisabled">
                            <mat-icon>get_app</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="col" style="height: 20px">

            </div>
        </div>
    </div>